import { removeInvalidItems } from '@/services/adapters/transformations/removeInvalidItems'
import { IBlockContent, ITip, TipSchema } from '@lifk/types'
import { z } from 'zod'

export interface ISanityTip extends Omit<ITip, 'name' | 'description'> {
  name: string
  description: IBlockContent
  es: ISpanishTip[]
}

interface ISpanishTip {
  name: string
  description: IBlockContent
}

const transformSanityTip = (sanityTip: ISanityTip): ITip => {
  let spanishTip: ISpanishTip | undefined
  if (sanityTip.es?.length) {
    spanishTip = sanityTip.es[0]
  }
  return {
    _id: sanityTip._id,
    name: {
      'en-us': sanityTip.name,
      'es-mx': spanishTip?.name ?? ''
    },
    description: {
      'en-us': sanityTip.description,
      'es-mx': spanishTip?.description ?? { blocks: [] }
    },
    icon: sanityTip.icon
  }
}

export const transformSanityTips = (
  sanityTips: ISanityTip[],
  disableValidations: boolean
): ITip[] => {
  const transformedTips = sanityTips.map((tip) => transformSanityTip(tip))
  const validation = z.array(TipSchema).safeParse(transformedTips)
  let tips: ITip[] = validation.data ?? []
  if (!validation.success) {
    tips = removeInvalidItems(
      transformedTips,
      validation.error,
      disableValidations
    )
  }
  return tips
}
